import {useTranslation} from 'react-i18next';

import {Payment} from '../../components/Payment/Payment';

import cls from './Order.module.scss'
export const Order = () => {

    const {t} = useTranslation()

    return (
        <div className={cls.page}>
            <h2>{t('Congratulations, your application has been approved!')}</h2>
            <Payment/>
        </div>
    )
}